<div
  (focus)="onMouseOverMenu()"
  (mouseenter)="resetTimeOut()"
  (mouseover)="onMouseOverMenu()"
  class="menu-container">

  <div
    (mouseleave)="onMouseLeftMenu()"
    [class.collapsed]="!isMenuExpanded"
    [class.expanded]="isMenuExpanded"
    id="navigation">
    @if (!subNav) {
      <div class="logo">
        @if (!showFullLogo) {
          <div>
            <app-logo-g></app-logo-g>
          </div>
        } @else {
          @if (showFullLogo) {
            <div (click)="increaseClickCount()">
              <app-logo-full></app-logo-full>
            </div>
          }
        }
      </div>
    }
    @if (userPages.length > 0) {
      <div class="scrollable-sidenav-div">
        @for (pageObj of userPages; track $index) {
          <div
            (click)="!pageObj?.multiple ? onNavigate(pageObj?.page, pageObj?.tab) : null"
            [id]="pageObj.page"
            [ngClass]="{
        'page-button': true,
        'accordion-menu-item': pageObj?.multiple,
        'beta': pageObj.beta,
        'fresh': pageObj.fresh,
        'selected': getNavigationPage === pageObj.page
        }">
            <ng-container>
              @if (pageObj.multiple) {
                <app-shared-accordion-item
                  [isOpen]="false"
                  [canToggle]="true"
                  class="accordion-group"
                  [id]="pageObj.page"
                  (accordionHeaderClicked)="expandMenuOnAccClick(pageObj?.page)">
                  <div class="header accordion-header additional-style">
                    <div class="accordion-label">
                      <span class="icon-wrapper">
                        <app-display-icon [colour]="iconColourEnum.constant_white" [icon]="pageObj.icon" class="icon"></app-display-icon>
                      </span>
                      <span class="menu-text">
                        {{ pageObj.text }}
                      </span>
                    </div>
                    <app-display-icon
                      class="ion-accordion-toggle-icon"
                      [colour]="iconColourEnum.constant_white"
                      [icon]="icon.chevronDown">
                    </app-display-icon>
                  </div>

                  <div class="body ion-padding">
                    @for (subPageObj of subPages[pageObj.page]; track $index) {
                      <div
                        (click)="onNavigate(subPageObj.page, subPageObj.tab)"
                        [id]="subPageObj.tab ? subPageObj.tab : subPageObj.page"
                        [ngClass]="{
                    'page-button': true,
                    'beta': pageObj.beta,
                    'fresh': pageObj.fresh,
                    'selected': getNavigationTab === subPageObj.tab
                  }">
                        <div
                             class="sub-page">
                          <span class="icon-container">
                            <app-display-icon [colour]="iconColourEnum.constant_white" [icon]="subPageObj.icon"
                                              class="icon"></app-display-icon>
                          </span>
                          <span class="sub-page-text">
                            {{ subPageObj.text }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                </app-shared-accordion-item>
              } @else {
                <span class="icon-wrapper">
                  <app-display-icon [colour]="iconColourEnum.constant_white" [icon]="pageObj.icon"
                                    class="display-icon"></app-display-icon>
                </span>
                <span class="menu-text-wrapper">
                  {{ pageObj.text }}
                </span>
              }
            </ng-container>
          </div>
        }
        @if (showFullLogo && clickCount > 9) {
          <app-mushroom-easter-egg></app-mushroom-easter-egg>
        }
        <div class="menu-toggle">
          @if (getNavigationPage !== navigationPage.Home && !isMobile) {
            <div
              (click)="onToggleMenu()"
              class="arrow">
                <app-display-icon
                  [ngClass]="{'rotated': isMenuExpanded}"
                  class="arrow-icon"
                  [icon]="icon.chevronRight">
                </app-display-icon>
              </div>
            }
          </div>
        <div class="styling-svg">
          <app-styling-svg [ngClass]="{'expanded': isMenuExpanded, 'collapsed': !isMenuExpanded}">
          </app-styling-svg>
        </div>
      </div>
      <div class="copyright-year">
        &copy; {{ currentYear }}
        <span class="rights" [class.show]="isMenuExpanded">
          All Rights Reserved
        </span>
        <br>
        <span class="version" [class.show]="isMenuExpanded">
          Version:
        </span>
        {{versionNumber}}

      </div>
    }
  </div>


</div>
